import service from '@/utils/axios-v2'

export function getInvoiceInfo() {
  return service({
    url: '/fleet/customer/invoice/count',
    method: 'get'
  })
}

export function getCompanyInfo() {
  return service({
    url: '/fleet/customer/invoice/billing/from',
    method: 'get'
  })
}

export function updateCompanyInfo(data) {
  return service({
    url: '/fleet/customer/invoice/edit/billing/from',
    method: 'post',
    data
  })
}

export function getInvoiceList(data) {
  return service({
    url: '/fleet/customer/invoice/page',
    method: 'post',
    data
  })
}

export function getCustomer() {
  return service({
    url: '/fleet/dispatch/enums/get',
    method: 'get'
  })
}

export function editCustomer(data) {
  return service({
    url: '/fleet/contact/edit',
    method: 'post',
    data
  })
}

export function getChooseCustomer() {
  return service({
    url: '/fleet/customer/invoice/choose/customer',
    method: 'get'
  })
}

export function getFactoringCompanyList() {
  return service({
    url: '/fleet/factoring/company/list',
    method: 'get'
  })
}

export function addFactoringCompany(data) {
  return service({
    url: '/fleet/factoring/company/add',
    method: 'post',
    data
  })
}

export function editFactoringCompany(data) {
  return service({
    url: '/fleet/factoring/company/edit',
    method: 'post',
    data
  })
}

export function getInvoiceCreateInfo(customerId) {
  return service({
    url: '/fleet/customer/invoice/create/info',
    method: 'get',
    params: { customerId }
  })
}

export function addLine(data) {
  return service({
    url: '/fleet/customer/invoice/item/batch/add',
    method: 'post',
    data
  })
}

export function editLine(data) {
  return service({
    url: '/fleet/customer/invoice/item/edit',
    method: 'post',
    data
  })
}

export function deleteLine(id) {
  return service({
    url: '/fleet/customer/invoice/item/delete',
    method: 'get',
    params: { id: id }
  })
}

export function addInvoice(data) {
  return service({
    url: '/fleet/customer/invoice/add',
    method: 'post',
    data
  })
}

export function editInvoice(data) {
  return service({
    url: '/fleet/customer/invoice/edit',
    method: 'post',
    data
  })
}

export function downloadPDF(data) {
  return service({
    url: '/fleet/customer/invoice/download/pdf',
    method: 'post',
    data
  })
}

export function downloadPDFAll(data) {
  return service({
    url: '/fleet/customer/invoice/download/all',
    method: 'post',
    data
  })
}

export function eidtInvoiceStatus(params) {
  return service({
    url: '/fleet/customer/invoice/change',
    method: 'get',
    params
  })
}

export function getInvoiceDetail(id) {
  return service({
    url: '/fleet/customer/invoice/profile',
    method: 'get',
    params: { id }
  })
}

export function sendInvoiceEmail(data) {
  return service({
    url: '/fleet/customer/invoice/send',
    method: 'post',
    data
  })
}

export function markInvoice(params) {
  return service({
    url: '/fleet/customer/invoice/change',
    method: 'get',
    params
  })
}

export function sendEmailAll(data) {
  return service({
    url: '/fleet/customer/invoice/email',
    method: 'post',
    data
  })
}

// load Financial
export function getLoadFinancial(loadId) {
  return service({
    url: `/fleet/customer/invoice/load/${loadId}`,
    method: 'get'
  })
}

export function getAllLoadIds(params) {
  return service({
    url: '/fleet/customer/invoice/all/load-id',
    method: 'get',
    params
  })
}

export function getLoadDocuments(data) {
  return service({
    url: '/fleet/document/v2/web/query/loads',
    method: 'post',
    data
  })
}

export function addInvoiceDocument(data) {
  return service({
    url: '/fleet/document/add/document',
    method: 'post',
    data
  })
}

export function getInvoiceAttachedDocuments(invoiceId) {
  return service({
    url: `/fleet/customer/invoice/${invoiceId}/documents`,
    method: 'get',
  })
}